// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/users/plugins

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function ElementLogout(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'ElementLogout',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement(
      'g',
      {fill: 'currentColor'},
      createElement('path', {d: 'M4 9L0 6l4-3zm0-3.454h3v.849H4z'}),
      createElement('path', {
        clipRule: 'evenodd',
        d: 'M5 11h6V1H5v1h5v8H5z',
        fillRule: 'evenodd',
      })
    )
  );
}
